import { ws } from "../../../utils/common";

export const removeVolunteerWS = async ({ id_association, id_user_association }) => {
    const res = await ws(
        "DELETE",
        process.env.REACT_APP_ENDPOINT + "user-association/" + id_association,
        null,
        { id_user_association },
        true
    );


    if (res.error) {
        throw res.data;
    } else {
        return res.data;
    }
}

export const changePermissionWS = async ({ id_user_association, admin, id_association }) => {
    const res = await ws(
        "PATCH",
        process.env.REACT_APP_ENDPOINT + "user-association/" + id_association,
        null,
        { id_user_association, admin },
        true
    );


    if (res.error) {
        throw res.data;
    } else {
        return res.data;
    }
}
